/**
 * cafe24 Module
 */
const getDefaultState = () => {
  return {
    mallId: null
  };
};
const state = getDefaultState();

const getters = {
  mallId: (state) => {
    return state.mallId;
  }
};

const mutations = {
  setMallId(state, shoppingMallId) {
    state.mallId = shoppingMallId;
  }
};

const actions = {};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/cafe24/index.js